import axios from "../axios";
import { ICataloguedItems } from "../../types/wizard-types";
import { AxiosReturn } from "../types";
import * as Requests from "../requests";
export const getLoyaltyGiftMenuApi = (
  token,
  pos_entity_id?: string
): AxiosReturn<ICataloguedItems[]> => {
  return axios.get(Requests.storeItems, {
    headers: {
      token,
    },
    params: {
      remove_gift_items: 1,
      pos_entity_id,
      ...(pos_entity_id ? { include_pos_entity_id: 1 } : {}),
    },
  });
};
